import { create } from 'zustand';

interface UnauthorizedReferrerState {
  referrerPath: string | null;
  setReferrerPath: (path: string | null) => void;
  clearReferrerPath: () => void;
}

/**
 * Zustand store for tracking the path a user attempted to access before being redirected to /unauthorized.
 * Syncs with sessionStorage for persistence across reloads and SSR boundaries.
 */
export const useUnauthorizedReferrerStore = create<UnauthorizedReferrerState>(set => ({
  referrerPath: typeof window !== 'undefined' ? sessionStorage.getItem('unauthorized_referrer') : null,
  setReferrerPath: path => {
    if (typeof window !== 'undefined') {
      if (path) {
        sessionStorage.setItem('unauthorized_referrer', path);
      } else {
        sessionStorage.removeItem('unauthorized_referrer');
      }
    }
    set({ referrerPath: path });
  },
  clearReferrerPath: () => {
    if (typeof window !== 'undefined') {
      sessionStorage.removeItem('unauthorized_referrer');
    }
    set({ referrerPath: null });
  },
}));
